import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * Create new orchid pro reminders
 */
export default async function postOrchidProReminder(
  nextReminder: AppointmentReminderCreate,
  onBehalfOf?: string,
): Promise<AppointmentReminder> {
  const res = await fetchOrchidAPI(
    `/api/users/v1/appointment_reminders/${
      onBehalfOf ? `?on_behalf_of=${onBehalfOf}` : ""
    }`,
    {
      method: "POST",
      body: JSON.stringify(nextReminder),
    },
  );
  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }

  return res.json();
}
